import { createContext, useContext, useState } from 'react';

import { FCWithChildren } from 'common/types';

import DeleteClientModal, {
  DeleteClientModalProps,
} from './components/DeleteClientModal';

type Modal = {
  name: 'delete';
  props: DeleteClientModalProps;
};

interface ContextType {
  openModal: (props: Modal) => void;
  hideModal: () => void;
}

const ClientModalsContext = createContext<ContextType>({
  hideModal: () => {},
  openModal: () => {},
});

export const ClientModalsProvider: FCWithChildren = ({ children }) => {
  const [modal, setModal] = useState<Modal | null>(null);

  return (
    <ClientModalsContext.Provider
      value={{
        hideModal: () => setModal(null),
        openModal: setModal,
      }}
    >
      {children}

      {modal?.name === 'delete' ? <DeleteClientModal {...modal.props} /> : null}
    </ClientModalsContext.Provider>
  );
};

export const useClientModals = () => {
  const context = useContext(ClientModalsContext);

  if (!context) {
    throw new Error(
      'useClientModals can only be used inside of a ClientModalsProvider',
    );
  }

  return context;
};
